import { t } from '../../../locales';
import { isFeatureFlagEnabled, featureFlag } from '../../entities/feature-flag';

// Tenants on the new Knowledge Base should never land on the legacy FAQ screens,
// even via bookmarks or shared links. Bounce them to the new KB instead.
const redirectLegacyFaqsIfOnV2 = (to, from, next) => {
	if (isFeatureFlagEnabled(featureFlag.KNOWLEDGE_BASE_V2)) {
		next('/v2/linker/knowledge-base/websites');
		return;
	}
	next();
};

const sharedAgentRoutes = {
	path: 'common',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'short-memory',
			component: () => import('./pages/short-memory/form.vue'),
			meta: {
				title: t('real-estate.short-memory'),
			},
		},
      {
			path: 'faqs',
			component: () => import('../verify-sy/pages/faqs/index.vue'),
			beforeEnter: redirectLegacyFaqsIfOnV2,
			meta: {
				title: () =>
					isFeatureFlagEnabled(featureFlag.CUSTOMER_SERVICE)
				? t('sidebar.knowledge-base')
				: t('verify-sy.faqs'),
			},
		},
		{
			path: 'faqs',
			component: () => import('../verify-sy/pages/faqs/index.vue'),
			meta: {
				title: () =>
					isFeatureFlagEnabled(featureFlag.CUSTOMER_SERVICE)
				? t('sidebar.knowledge-base')
				: t('verify-sy.faqs'),
			},
		},
		{
			path: 'faqs-v2',
			component: () => import('./pages/faqs/index.vue'),
			beforeEnter: redirectLegacyFaqsIfOnV2,
			meta: {
				title: t('verify-sy.faqs'),
			},
		},
		{
			path: 'try-agent',
			component: () => import('./pages/try-agent/index.vue'),
			meta: {
				title: t('agents.try-agent'),
			},
		},
	],
};

export { sharedAgentRoutes };
